export enum WebFormLangTemplateEnum {
  Swedish = 'sv',
  English = 'en',
}
